













import {Vue, Component, Prop} from 'vue-property-decorator'
import MyForm from '../MyForm'
import axios from 'axios';

@Component({})
export default  class NewList extends Vue{
    $store: any

    @Prop() todoId!: number


    private form = new MyForm({
        body: '',
        isCompleted: false
    })


  get addingEnabled(): boolean{
      return this.$store.state.todoList.addingEnabled;
  }


    addList(): void{
        axios.post(`/api/todo-lists/${this.todoId}`, this.form)
        .then(({data}) => {
            this.$emit('listAdded', data)
            this.form.reset()
            this.form.isCompleted = false
        })
        .catch(error => {
            this.form.error = error.response.data.errors
        })
    }
 }
